var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SvgWrapper',{attrs:{"viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M96 197.333h320v32H96zm72 101.334h176v32H168zM216 400h80v32h-80zM48 96h416v32H48z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }